import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false, chunkName: 'login' }
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
      meta: { requiresAuth: true, title: '商标检索', chunkName: 'home' }
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/DataUpload.vue'),
      meta: { requiresAuth: true, requiresUpload: true, title: '数据上传', chunkName: 'data-upload' }
    },
    {
      path: '/analysis',
      name: 'analysis', 
      component: () => import('@/views/DataAnalysis.vue'),
      meta: { requiresAuth: true, requiresUpload: true, requiresLook: true, title: '数据分析', chunkName: 'data-analysis' }
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('@/views/PricingManagement.vue'),
      meta: { requiresAuth: true, requiresUpload: true, requiresLook: true, title: '报价管理', chunkName: 'pricing' }
    },
    {
      path: '/ai-templates',
      name: 'ai-templates',
      component: () => import('@/views/AiTemplateManagement.vue'),
      meta: { requiresAuth: true, requiresUpload: true, title: 'AI模板管理', chunkName: 'ai-templates' }
    },
    {
      path: '/system',
      name: 'system',
      component: () => import('@/views/SystemManagement.vue'),
      meta: { requiresAuth: true, requiresAdmin: true, title: '系统管理', chunkName: 'system' },
      children: [
        {
          path: '',
          name: 'system-default',
          redirect: '/system/users'
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('@/views/UserManagement.vue'),
          meta: { title: '用户管理', chunkName: 'user-management' }
        },
        {
          path: 'ai-config',
          name: 'ai-config',
          component: () => import('@/views/AiConfig.vue'),
          meta: { title: 'AI配置', chunkName: 'ai-config' }
        },
        {
          path: 'cleanup',
          name: 'cleanup',
          component: () => import('@/views/FileCleanup.vue'),
          meta: { title: '文件清理', chunkName: 'file-cleanup' }
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore()
  
  // 如果用户未登录且本地有存储的信息，尝试恢复登录状态
  if (!userStore.isLoggedIn && localStorage.getItem('token')) {
    userStore.initFromStorage()
  }
  
  // 检查路由是否需要认证
  if (to.meta.requiresAuth) {
    if (!userStore.isLoggedIn) {
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }
    
    // 检查管理员权限
    if (to.meta.requiresAdmin && !userStore.isAdmin()) {
      next({ name: 'home' })
      return
    }
    
    // 检查上传权限
    if (to.meta.requiresUpload && !userStore.hasUploadPermission()) {
      next({ name: 'home' })
      return
    }

    // 检查数据分析权限（需要同时具有上传和查看权限）
    if (to.meta.requiresLook && (!userStore.hasUploadPermission() || !userStore.hasLookPermission())) {
      next({ name: 'home' })
      return
    }
  }
  
  // 已登录用户访问登录页，重定向到首页
  if (to.name === 'login' && userStore.isLoggedIn) {
    next({ name: 'home' })
    return
  }
  
  next()
})

export default router
